import React, { useState } from "react";
import { Link } from "react-router-dom";

import {MdKeyboardArrowDown} from '../assets/icons/vander'

export default function Faq(){
    const [activeIndex, setActiveIndex] = useState(1)
    const accordionData = [
        {
            id:1,
            title:'Do we need to pay for marketplace?',
            desc:'No, it is free to look for products and also, list your products in MinuAI.'
        },
        {
            id:2,
            title:'How can we be sure that product is GDPR or EU AI Act compliant?',
            desc:'Companies can self-declare or use 3rd party auditor to show their compliance. If these companies operate in EU, they have to comply with regulations.'
        },
        {
            id:3,
            title:'Do you give support for listed products?',
            desc:'No, we are not reseller of the products. We give platform for listing and marketing AI products and we do not give support for this product. However, you will have option to contact to the owners of solutions on MinuAI.'
        },
        {
            id:4,
            title:'Can I advertise my product on MinuAI?',
            desc:'Yes, you will be able to promote your AI product.'
        },
    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 items-center md:gap-[30px]">
                    <div className="lg:col-span-4 md:mb-0 mb-8">
                        <h3 className="mb-2 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">FAQ</h3>

                        
                    </div>

                    <div className="lg:col-span-8 md:mt-0 mt-8">
                        {accordionData.map((item,index)=>{
                            return(
                                <div className="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden mt-4" key={index}>
                                    <h2 className="text-base font-semibold" id="accordion-collapse-heading-1">
                                        <button type="button" onClick={()=>setActiveIndex(item.id)} className={`${activeIndex === item.id ? "bg-gray-50 dark:bg-slate-800 text-amber-400" : ""} flex justify-between items-center p-5 w-full font-medium text-start`}>
                                            <span>{item.title}</span>
                                            <MdKeyboardArrowDown className={`${activeIndex === item.id ? "rotate-180" : ""} w-4 h-4 shrink-0`}/>
                                        </button>
                                    </h2>
                                    <div className={activeIndex === item.id ? "" : "hidden"}>
                                        <div className="p-5">
                                            <p className="text-slate-400 dark:text-gray-400">{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div> 
        </>
    )
}